import React from "react";
import ModalDatePicker from "@otrl/ui/dist/components/date/ModalDatePicker";
import DateTime from "@otrl/ui/dist/models/DateTime";
import { add } from "@otrl/ui/dist/lib/date";
import "styles/components/recentOrderModal.scss";

export const RecentOrderModal = ({ minDate, fare, closeModal, onHandoff }) => {
    return (
        <div className='otrl-jp__recent-order-modal'>
            <ModalDatePicker
                fare={fare}
                dateTime={new DateTime(minDate)}
                isSeason={fare.ticketType?.isSeason}
                onClose={closeModal}
                onSave={(dateTime) => onHandoff(fare, dateTime.toDate())}
                minDate={minDate}
                maxDate={add(minDate, { weeks: 4 })}
                datePickerClassName='otrl-ui__date-picker--full-width'
            />
        </div>
    )
}
